import styles from '../components/MentionComposeStyles.scss';

export default function getMentionClassName() {
    return styles.mentions;
}
